import React, { useState } from "react";
import "./Login.css"; // Updated CSS file
import ApiUrl from "../environment/Apiurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    setError("");

    const usernameTrimmed = username.trim();
    const passwordTrimmed = password.trim();

    if (!usernameTrimmed) {
      setError("Please enter username");
      return;
    }
    if (!passwordTrimmed) {
      setError("Please enter password");
      return;
    }

    setIsLoading(true);

    try {
      console.log("Attempting login with payload:", {
        username: usernameTrimmed,
        password: passwordTrimmed,
      });

      const response = await axios.post(`${ApiUrl}/login`, {
        user_id: usernameTrimmed,
        password: passwordTrimmed,
      });

      console.log("Login response:", response.data);

      const data = response.data;

      if (data.status === "success") {
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("role", data.user.role);
        localStorage.setItem("user_id", data.user.user_id);
        navigate("/dashboard");
      } else {
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      if (err.response) {
        const errorMsg =
          err.response.data?.message ||
          "Login failed. Please check your credentials.";
        setError(errorMsg);
      } else if (err.request) {
        setError(
          "No response from server. Please check your connection or server status."
        );
      } else {
        setError("An error occurred. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login">
      <div className="login-form-container">
        <div className="login-form">
          <div className="text-center mb-4">
            <div className="logoimg"></div>
          </div>
          <h4 className="form-title">Username</h4>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            autoComplete="username"
          />
          <h4 className="form-title mt-4">Password</h4>
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="current-password"
            />
            <span
              className="password-toggle"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className="bi bi-eye-slash"></i>
              ) : (
                <i className="bi bi-eye"></i>
              )}
            </span>
          </div>
          <button
            className="btn btn-login"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
          {error && (
            <div className="alert alert-danger mt-2" role="alert">
              {error}
            </div>
          )}
        </div>
      </div>
      <div className="ring-container">
        <div className="reflection"></div>
      </div>
    </div>
  );
}

export default Login;